/* Product compare: a list of up to 4 handles in localStorage, toggled from
   product cards and the product page, shown in a floating bar and laid out as
   a spec table on /search?view=compare. */
(function () {
  if (window.__compareInit) return;
  window.__compareInit = true;
  var KEY = '3afret_compare', MAX = 6;
  var routes = window.themeRoutes || {};
  var root = (routes.root || '/').replace(/\/$/, '');
  var PAGE_URL = (routes.search_url || root + '/search') + '?view=compare';
  var BROWSE_URL = root + '/collections/smartphones';
  var moneyFormat = window.themeMoneyFormat || '{{amount}} EGP';

  function money(cents) {
    var n = Math.round(cents) / 100;
    var s = n.toLocaleString('en-EG', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]+>/g, '');
  }
  function load() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a.filter(function (x) { return x && x.h; }).slice(0, MAX) : []; }
    catch (e) { return []; }
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    renderBar(); syncToggles();
    document.dispatchEvent(new CustomEvent('compare:change', { detail: { items: list } }));
  }
  function has(h) { return load().some(function (x) { return x.h === h; }); }
  function remove(h) { save(load().filter(function (x) { return x.h !== h; })); }
  function infoFrom(btn) {
    var card = btn.closest('[data-product-card]');
    var title = '', img = '', url = '';
    if (card) {
      var t = card.querySelector('.card__title a, .card__title'); title = t ? t.textContent.trim() : '';
      var im = card.querySelector('.card__media img'); img = im ? (im.currentSrc || im.src) : '';
      var a = card.querySelector('.card__title a, a.card__media'); url = a ? a.getAttribute('href') : '';
    } else {
      var h1 = document.querySelector('.product__title, h1'); title = h1 ? h1.textContent.trim() : document.title;
      var pm = document.querySelector('.product-media img, .product__media img, main img'); img = pm ? (pm.currentSrc || pm.src) : '';
      url = location.pathname;
    }
    return { h: btn.dataset.handle, t: title, i: img, u: url || root + '/products/' + btn.dataset.handle };
  }
  function toggle(btn) {
    var h = btn.dataset.handle; if (!h) return;
    var list = load();
    if (has(h)) { remove(h); return; }
    if (list.length >= MAX) { flash('You can compare up to ' + MAX + ' products. Remove one first.'); return; }
    list.push(infoFrom(btn)); save(list);
  }
  function syncToggles() {
    var list = load();
    document.querySelectorAll('[data-compare-toggle]').forEach(function (b) {
      var on = list.some(function (x) { return x.h === b.dataset.handle; });
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var span = b.querySelector('span');
      if (span && b.dataset.labelOn) {
        var label = on ? b.dataset.labelOn : b.dataset.labelOff;
        if (span.textContent !== label) span.textContent = label; /* only write on change: writes are DOM mutations */
      }
    });
  }
  var flashTimer;
  function flash(msg) {
    var bar = document.querySelector('.compare-bar'); if (!bar) return;
    var el = bar.querySelector('.compare-bar__flash'); el.textContent = msg; el.hidden = false;
    clearTimeout(flashTimer); flashTimer = setTimeout(function () { el.hidden = true; }, 3200);
  }

  /* ---- floating bar ---- */
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function ensureBar() {
    var bar = document.querySelector('.compare-bar');
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'compare-bar'; bar.hidden = true; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Compare products');
    document.body.appendChild(bar);
    bar.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-compare-remove]'); if (rm) { remove(rm.dataset.compareRemove); return; }
      if (e.target.closest('[data-compare-clear]')) { save([]); return; }
      if (e.target.closest('[data-compare-collapse]')) { bar.classList.toggle('is-collapsed'); }
    });
    return bar;
  }
  function renderBar() {
    if (document.getElementById('compare-page')) return;
    var list = load(), bar = ensureBar();
    if (!list.length) {
      bar.hidden = true;
      document.body.classList.remove('has-compare-bar');
      document.body.style.removeProperty('--compare-bar-h');
      return;
    }
    var slots = '';
    list.forEach(function (x) {
      slots += '<li class="compare-bar__item">' +
        (x.i ? '<img src="' + esc(x.i) + '" alt="" loading="lazy">' : '<span class="compare-bar__ph"></span>') +
        '<a class="compare-bar__title" href="' + esc(x.u) + '">' + esc(x.t) + '</a>' +
        '<button type="button" class="compare-bar__remove" data-compare-remove="' + esc(x.h) + '" aria-label="Remove ' + esc(x.t) + '">&times;</button></li>';
    });
    // One "add" slot, not one per unused place: with six places the tiles would
    // otherwise be squeezed to a sliver even when only two products are chosen.
    var slotCount = list.length;
    if (list.length < MAX) {
      slots += '<li class="compare-bar__item compare-bar__item--empty"><a href="' + esc(BROWSE_URL) + '"><span class="compare-bar__plus" aria-hidden="true">+</span><span>Add product</span></a></li>';
      slotCount += 1;
    }
    bar.innerHTML =
      // The handle is a direct child of the bar so it centres on the sheet
      // itself, not on the text block, which sits inside the page gutters.
      '<button type="button" class="compare-bar__toggle" data-compare-collapse aria-label="Show or hide the compare list"></button>' +
      '<div class="compare-bar__inner page-width">' +
        '<div class="compare-bar__head">' +
          '<strong>Compare products</strong><span class="compare-bar__count">' + list.length + ' of ' + MAX + '</span>' +
          '<button type="button" class="compare-bar__clear" data-compare-clear>' + ICONS.trash + '<span>Clear all</span></button>' +
          '<span class="compare-bar__flash" hidden></span>' +
        '</div>' +
        '<ul class="compare-bar__items">' + slots + '</ul>' +
        '<a class="btn compare-bar__go' + (list.length < 2 ? ' is-disabled' : '') + '" href="' + esc(PAGE_URL) + '"' + (list.length < 2 ? ' aria-disabled="true" tabindex="-1"' : '') + '><span>Compare products</span>' + ICONS.arrowRight + '</a>' +
      '</div>';
    bar.style.setProperty('--compare-slots', slotCount);
    bar.hidden = false;
    document.body.classList.add('has-compare-bar');
    measureBar(bar);
  }

  // Publish the bar's height so the page can reserve exactly the right space
  // beneath it; on phones the bar sits on top of the fixed bottom nav bar.
  function measureBar(bar) {
    requestAnimationFrame(function () {
      document.body.style.setProperty('--compare-bar-h', bar.offsetHeight + 'px');
    });
  }

  /* ---- compare page ---- */
  var cache = {};
  function fetchProduct(h) {
    if (!cache[h]) cache[h] = fetch(root + '/products/' + h + '.js').then(function (r) { if (!r.ok) throw new Error(h); return r.json(); }).catch(function () { return null; });
    return cache[h];
  }

  function closest(target, selector) {
    var node = target;
    while (node) {
      if (node.nodeType === 1) {
        if (node.matches && node.matches(selector)) return node;
        if (node.closest) {
          var found = node.closest(selector);
          if (found) return found;
        }
      }
      node = node.parentElement || node.parentNode;
    }
    return null;
  }
  function specRows(p) {
    var rows = [], seen = {};
    var ALIAS = { storage: 'Internal Storage', storge: 'Internal Storage', 'internal storage': 'Internal Storage', colour: 'Color', color: 'Color', os: 'Operating System', 'operating system': 'Operating System' };
    function add(label, value) {
      label = label.trim(); var k = label.toLowerCase();
      if (ALIAS[k]) { label = ALIAS[k]; k = label.toLowerCase(); }
      if (!k || seen[k] || !value) return;
      seen[k] = true; rows.push([label, String(value).trim()]);
    }
    add('Price', p.compare_at_price && p.compare_at_price > p.price ? money(p.price) + ' <s>' + money(p.compare_at_price) + '</s>' : money(p.price));
    add('Brand', p.vendor);
    add('Category', p.type);
    (p.options || []).forEach(function (o) { if (o.name && o.values) add(o.name, o.values.join(', ')); });
    try {
      var doc = new DOMParser().parseFromString(p.description || '', 'text/html');
      doc.querySelectorAll('tr').forEach(function (tr) {
        var cells = tr.querySelectorAll('th,td'); if (cells.length < 2) return;
        add(cells[0].textContent, cells[1].textContent);
      });
      doc.querySelectorAll('li').forEach(function (li) {
        var m = li.textContent.split(':'); if (m.length >= 2 && m[0].length < 40) add(m[0], m.slice(1).join(':'));
      });
    } catch (e) {}
    add('Availability', p.available ? 'In stock' : 'Sold out');
    return rows;
  }
  /* Lucide-style outline icons: one consistent 24px viewBox and stroke. */
  var ICONS = {
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>',
    arrowRight: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.83 8.83a2 2 0 0 0 2.828 0l6.172-6.172a2 2 0 0 0 0-2.828z"/><circle cx="7.5" cy="7.5" r="1"/></svg>',
    info: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>',
    chart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 3v18h18"/><path d="M7 16v-3"/><path d="M12 16V8"/><path d="M17 16V5"/></svg>',
    cpu: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="16" height="16" x="4" y="4" rx="2"/><rect width="6" height="6" x="9" y="9" rx="1"/><path d="M9 1v3"/><path d="M15 1v3"/><path d="M9 20v3"/><path d="M15 20v3"/><path d="M20 9h3"/><path d="M20 14h3"/><path d="M1 9h3"/><path d="M1 14h3"/></svg>',
    monitor: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="20" height="14" x="2" y="3" rx="2"/><path d="M8 21h8"/><path d="M12 17v4"/></svg>',
    database: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><ellipse cx="12" cy="5" rx="8" ry="3"/><path d="M4 5v7c0 1.66 3.58 3 8 3s8-1.34 8-3V5"/><path d="M4 12v7c0 1.66 3.58 3 8 3s8-1.34 8-3v-7"/></svg>',
    camera: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 4h-5L8 7H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z"/><circle cx="12" cy="13" r="3"/></svg>',
    wifi: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 13a10 10 0 0 1 14 0"/><path d="M8.5 16.5a5 5 0 0 1 7 0"/><path d="M2 9a15 15 0 0 1 20 0"/><path d="M12 20h.01"/></svg>',
    scan: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="2"/><path d="M12 2v3"/><path d="M12 19v3"/><path d="M2 12h3"/><path d="M19 12h3"/></svg>',
    battery: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="16" height="10" x="3" y="7" rx="2"/><path d="M21 10v4"/><path d="M7 10v4"/><path d="M11 10v4"/></svg>',
    palette: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3a9 9 0 0 0 0 18h1.5a1.5 1.5 0 0 0 0-3H12a1.5 1.5 0 0 1 0-3h1a8 8 0 0 0 8-8.5A9 9 0 0 0 12 3Z"/><circle cx="7.5" cy="10" r=".8"/><circle cx="10" cy="6.5" r=".8"/><circle cx="15" cy="6.5" r=".8"/><circle cx="18" cy="10" r=".8"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 13c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V5l8-3 8 3z"/><path d="m9 12 2 2 4-4"/></svg>',
    scale: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m16 16 3-8 3 8a5 5 0 0 1-6 0Z"/><path d="m2 16 3-8 3 8a5 5 0 0 1-6 0Z"/><path d="M7 21h10"/><path d="M12 3v18"/><path d="M3 7h18"/></svg>'
  };
  var GROUPS = [
    { key: 'price', title: 'Price & Availability', icon: ICONS.tag, tone: 'blue', labels: ['Price', 'Availability'] },
    { key: 'basic', title: 'Basic Information', icon: ICONS.info, tone: 'blue', labels: ['Brand', 'Category'] },
    { key: 'network', title: 'Network', icon: ICONS.chart, tone: 'blue', labels: ['Network'] },
    { key: 'performance', title: 'Performance', icon: ICONS.cpu, tone: 'green', labels: ['Chipset', 'CPU', 'GPU'] },
    { key: 'display', title: 'Display', icon: ICONS.monitor, tone: 'purple', labels: ['Display Size', 'Display Type'] },
    { key: 'memory', title: 'Memory & Storage', icon: ICONS.database, tone: 'yellow', labels: ['RAM', 'Internal Storage'] },
    { key: 'camera', title: 'Camera', icon: ICONS.camera, tone: 'red', labels: ['Primary Camera', 'Secondary Camera'] },
    { key: 'connectivity', title: 'Connectivity', icon: ICONS.wifi, tone: 'blue', labels: ['Connectivity'] },
    { key: 'sensors', title: 'Sensors', icon: ICONS.scan, tone: 'purple', labels: ['Sensors'] },
    { key: 'battery', title: 'Battery', icon: ICONS.battery, tone: 'green', labels: ['Battery'] },
    { key: 'design', title: 'Design', icon: ICONS.palette, tone: 'yellow', labels: ['Color'] },
    { key: 'other', title: 'Other', icon: ICONS.shield, tone: 'purple', labels: ['Warranty', 'Operating System', 'OS Version'] }
  ];

  /* Compact product-name row that appears after the full cards have scrolled past. */
  var stickyNamesState = { cards: null, names: null, hideTimer: null, active: false };
  var stickyNamesBound = false;
  function updateStickyNames() {
    var cards = stickyNamesState.cards;
    var names = stickyNamesState.names;
    if (!cards || !names || !cards.isConnected || !names.isConnected) return;
    var header = document.querySelector('.header-section');
    var headerHeight = header ? header.getBoundingClientRect().height : 0;
    var trigger = cards.getBoundingClientRect().bottom + window.scrollY - headerHeight - 1;
    // Hysteresis. The site header changes height as the announcement bar
    // scrolls away, which moves the trigger under our feet; without a dead band
    // the row switches on and off several times a second around that point,
    // which reads as a shudder on a phone.
    var active = stickyNamesState.active;
    if (window.scrollY >= trigger) active = true;
    else if (window.scrollY < trigger - 60) active = false;
    // Every step below is guarded: `classList.add` of a class that is already
    // there still rewrites the class attribute, and doing that on each frame
    // makes the browser restyle the row continuously while you scroll.
    if (active !== stickyNamesState.active) {
      if (stickyNamesState.hideTimer) { window.clearTimeout(stickyNamesState.hideTimer); stickyNamesState.hideTimer = null; }
      stickyNamesState.active = active;
      if (active) {
        names.hidden = false;
        window.requestAnimationFrame(function () {
          if (names.isConnected && stickyNamesState.names === names && stickyNamesState.active &&
              !names.classList.contains('is-visible')) {
            names.classList.add('is-visible');
          }
        });
      } else {
        if (names.classList.contains('is-visible')) names.classList.remove('is-visible');
        stickyNamesState.hideTimer = window.setTimeout(function () {
          if (!names.classList.contains('is-visible')) names.hidden = true;
        }, 180);
      }
    }
    if (active) {
      var pane = names.parentElement;
      if (pane && pane.hasAttribute('data-compare-sync') && pane.scrollLeft !== syncX) pane.scrollLeft = syncX;
    }
    // Write only on a real change. Setting attributes and custom properties on
    // every scroll event forces a layout each frame, which is felt as a shudder
    // while scrolling on a phone.
    var ariaHidden = active ? 'false' : 'true';
    if (names.getAttribute('aria-hidden') !== ariaHidden) names.setAttribute('aria-hidden', ariaHidden);
    // The offset has to land on whichever element is actually pinned, and a
    // custom property set on a child never reaches its parent.
    var pinned = names.closest('.compare-sticky-anchor') || names;
    // `top` is a CSS length, and the site renders at 90% on desktop through
    // `zoom`. getBoundingClientRect() reports screen pixels, which are 10%
    // short, so the row would sit that much too high and slide under the site
    // header. offsetHeight is in layout pixels, which is what `top` expects.
    var stickyOffset = (header ? header.offsetHeight : 0) + 'px';
    if (pinned.style.getPropertyValue('--compare-sticky-top') !== stickyOffset) {
      pinned.style.setProperty('--compare-sticky-top', stickyOffset);
    }
  }
  function setupStickyNames(cards, names) {
    stickyNamesState.cards = cards;
    stickyNamesState.names = names;
    if (!stickyNamesBound) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () { ticking = false; updateStickyNames(); });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      stickyNamesBound = true;
    }
    updateStickyNames();
  }

  // The product cards, the pinned name row and every spec table are separate
  // horizontal scrollers, so scrolling one has to carry the others with it or
  // the values stop lining up with the product they belong to.
  var syncX = 0;
  function syncScrollers(host) {
    syncX = 0;
    var panes = [].slice.call(host.querySelectorAll('[data-compare-sync]'));
    if (panes.length < 2) return;
    var driver = null, locked = false;

    // Only the pane the finger actually grabbed drives the others, and only it
    // keeps `scroll-snap-type`.
    //
    // Handing the snapping back to every pane after a gesture caused a loop:
    // each one settled on its own nearest column, that settling fired a scroll
    // event, whichever fired first became the new driver and pushed its
    // position onto the rest, which set them settling again. The cards visibly
    // slid left and right. So a scroll event from anything but the current
    // driver is ignored, and the driver only changes on a real gesture.
    function take(pane) {
      if (driver === pane) return;
      driver = pane;
      pane.style.scrollSnapType = '';
      panes.forEach(function (other) { if (other !== pane) other.style.scrollSnapType = 'none'; });
    }

    panes.forEach(function (pane) {
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (type) {
        pane.addEventListener(type, function () { take(pane); }, { passive: true });
      });
      pane.addEventListener('scroll', function () {
        if (locked || driver !== pane) return;
        locked = true;
        syncX = pane.scrollLeft;
        panes.forEach(function (other) { if (other !== pane && other.scrollLeft !== syncX) other.scrollLeft = syncX; });
        window.requestAnimationFrame(function () { locked = false; });
      }, { passive: true });
    });
  }

  function renderPage() {
    var host = document.getElementById('compare-page'); if (!host) return;
    var list = load();
    if (!list.length) {
      host.innerHTML = '<div class="compare-page__empty"><p>' + esc(host.dataset.empty || 'Your compare list is empty.') + '</p><a class="btn" href="' + esc(host.dataset.shopUrl || BROWSE_URL) + '">Browse phones</a></div>';
      return;
    }
    host.innerHTML = '<p class="compare-page__loading">Loading…</p>';
    Promise.all(list.map(function (x) { return fetchProduct(x.h); })).then(function (products) {
      var items = []; products.forEach(function (p, i) { if (p) items.push({ p: p, meta: list[i] }); });
      if (!items.length) { save([]); renderPage(); return; }
      var specs = items.map(function (it) { return specRows(it.p); });
      var CANON = ['Price', 'Brand', 'Category', 'Network', 'Chipset', 'CPU', 'GPU', 'Display Size', 'Display Type', 'RAM', 'Internal Storage', 'Operating System', 'OS Version', 'Primary Camera', 'Secondary Camera', 'Connectivity', 'Sensors', 'Battery', 'Color', 'Warranty'];
      var labels = []; specs.forEach(function (rows) { rows.forEach(function (r) { if (labels.indexOf(r[0]) < 0) labels.push(r[0]); }); });
      labels.sort(function (a, b) { var ia = CANON.indexOf(a), ib = CANON.indexOf(b); if (ia < 0) ia = 900 + labels.indexOf(a); if (ib < 0) ib = 900 + labels.indexOf(b); return ia - ib; });
      /* stock status always reads last, whatever order the descriptions used */
      labels = labels.filter(function (l) { return l !== 'Availability'; }).concat(labels.indexOf('Availability') > -1 ? ['Availability'] : []);
      // Publish the count on the host so the spec tables can size to it too.
      host.style.setProperty('--compare-product-count', items.length);
      // The row has one column per product plus the row-name column, so an add
      // tile appended after the products had nowhere to go and wrapped onto a
      // second row. It takes the row-name column instead: same row, beside the
      // cards, and on a phone it stays pinned there while the products scroll.
      var addTile = items.length < MAX
        ? '<article class="compare-product-card compare-product-card--add"><a href="' + esc(host.dataset.shopUrl || BROWSE_URL) + '"><span class="compare-product-card__plus">+</span><strong>Add product</strong><small>Compare up to ' + MAX + ' products</small></a></article>'
        : '<span class="compare-products__spacer" aria-hidden="true"></span>';
      var cards = '<div class="compare-scroll compare-scroll--cards" data-compare-sync><div class="compare-products" style="--compare-product-count:' + items.length + '">' + addTile;
      items.forEach(function (it) {
        var p = it.p;
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') : '';
        var price = money(p.price);
        if (p.compare_at_price && p.compare_at_price > p.price) price += ' <s>' + money(p.compare_at_price) + '</s>';
        cards += '<article class="compare-product-card">' +
          '<button type="button" class="compare-product-card__remove" data-compare-remove="' + esc(p.handle) + '" aria-label="Remove ' + esc(p.title) + '">&times;</button>' +
          '<a class="compare-product-card__media" href="' + esc(root + '/products/' + p.handle) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '<span class="compare-product-card__placeholder"></span>') + '</a>' +
          '<a class="compare-product-card__title" href="' + esc(root + '/products/' + p.handle) + '"><span>' + esc(p.title) + '</span></a>' +
          '<span class="compare-product-card__price">' + price + '</span>' +
          '<a class="btn btn--small compare-product-card__view" href="' + esc(root + '/products/' + p.handle) + '">View product</a>' +
          '</article>';
      });
      cards += '</div></div>';
      cards += '<div class="compare-sticky-anchor"><div class="compare-scroll compare-scroll--names" data-compare-sync><div class="compare-sticky-names" data-compare-sticky-names hidden aria-hidden="true" style="--compare-product-count:' + items.length + '"><span class="compare-sticky-names__label"><span class="compare-sticky-names__label-icon" aria-hidden="true">' + ICONS.scale + '</span><span>Comparing</span></span>';
      items.forEach(function (it) { cards += '<span class="compare-sticky-names__product">' + esc(it.p.title) + '</span>'; });
      cards += '</div></div></div><div class="compare-page__controls"><label class="compare-page__diff"><input type="checkbox" data-compare-diff><span>Show only differences</span></label></div>';

      var groups = '<div class="compare-groups">';
      GROUPS.forEach(function (group) {
        var groupLabels = group.labels.filter(function (label) { return labels.indexOf(label) > -1; });
        if (group.key === 'other') {
          labels.forEach(function (label) {
            var assigned = GROUPS.some(function (g) { return g !== group && g.labels.indexOf(label) > -1; });
            if (!assigned && groupLabels.indexOf(label) < 0) groupLabels.push(label);
          });
        }
        if (!groupLabels.length) return;
        var rowsHtml = '';
        groupLabels.forEach(function (label) {
          var vals = specs.map(function (rows) { var r = rows.filter(function (x) { return x[0] === label; })[0]; return r ? r[1] : '—'; });
          var same = vals.every(function (v) { return v === vals[0]; });
          rowsHtml += '<tr class="' + (same ? 'is-same' : 'is-diff') + (label === 'Price' ? ' compare-row--price' : '') + '"><th scope="row">' + esc(label) + '</th>';
          vals.forEach(function (v) { rowsHtml += '<td>' + (label === 'Price' ? v : esc(v)) + '</td>'; });
          rowsHtml += '</tr>';
        });
        groups += '<section class="compare-group compare-group--' + group.tone + '"><h2 class="compare-group__title"><span class="compare-group__icon" aria-hidden="true">' + group.icon + '</span>' + esc(group.title) + '</h2><div class="compare-table__scroll" data-compare-sync><table class="compare-table"><tbody>' + rowsHtml + '</tbody></table></div></section>';
      });
      groups += '</div>';
      host.innerHTML = cards + groups;
      var diff = host.querySelector('[data-compare-diff]');
      diff.addEventListener('change', function () { host.classList.toggle('compare-page--diff-only', diff.checked); });
      syncScrollers(host);
      setupStickyNames(host.querySelector('.compare-products'), host.querySelector('[data-compare-sticky-names]'));
    });
  }

  document.addEventListener('click', function (e) {
    var t = closest(e.target, '[data-compare-toggle]'); if (t) { e.preventDefault(); toggle(t); return; }
    var rm = closest(e.target, '#compare-page [data-compare-remove]'); if (rm) { e.preventDefault(); remove(rm.dataset.compareRemove); renderPage(); }
  });
  document.addEventListener('compare:change', function () { if (document.getElementById('compare-page')) renderPage(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { renderBar(); syncToggles(); renderPage(); } });
  /* Cards rendered later (quick view, sliders, section re-renders): re-sync only when a
     mutation actually adds a compare toggle, and never more than once per frame. */
  var syncQueued = false;
  function queueSync() { if (syncQueued) return; syncQueued = true; requestAnimationFrame(function () { syncQueued = false; syncToggles(); }); }
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.hasAttribute('data-compare-toggle') || n.querySelector('[data-compare-toggle]'))) { queueSync(); return; }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', function () {
    var bar = document.querySelector('.compare-bar');
    if (bar && !bar.hidden) measureBar(bar);
  });

  function init() { renderBar(); syncToggles(); renderPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();